// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3VIyb5kHJtlKex {\n  font-weight: bold;\n}\n._22aV05GMG7LQCd {\n  word-break: break-word;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colons": "_3VIyb5kHJtlKex",
	"name": "_22aV05GMG7LQCd"
};
export default ___CSS_LOADER_EXPORT___;
